<template>
  <div class="article">
    <div class="article_return" @click="clickReturn">
      <img src="../../assets/img/pc/return.png" alt="" />
    </div>
    <div class="article_content">
      <div
        class="article_content_item"
        v-for="(item, index) in articleList"
        :key="index"
        @click="clickArticleItem(item.extUrl)"
      >
        <div class="article_content_item_left">
          <img :src="item.thumbnail" alt="" />
        </div>
        <div class="article_content_item_right">
          <div class="article_content_item_right_title">{{ item.name }}</div>
          <div class="article_content_item_right_time">{{ item.intro }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['articleList'],
  methods: {
    clickReturn() {
      this.$emit('return')
    },
    clickArticleItem(url) {
      window.open(url, '_blank')
      // this.iframeShow = true
      // this.url = 'https://www.baidu.com'
    },
  },
}
</script>
<style lang="scss">
@import '../../assets/css/pc.scss';
.article {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9;
  background: url('../../assets/img/pc/cover-bg.png') #eee no-repeat center
    center/100% 100%;
  .article_return {
    cursor: pointer;
    width: rem(158);
    height: rem(85);
    position: absolute;
    left: rem(40);
    top: rem(40);
    z-index: 9;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  .article_content {
    width: rem(1600);
    height: rem(880);
    overflow-y: auto;
    overflow-x: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: url('../../assets/img/pc/cover_content-bg.png') #fff no-repeat
      center center/110% 111%;
    border-radius: 10px;
    padding: rem(50) rem(150);
    box-sizing: border-box;
    &::-webkit-scrollbar-track {
      // background: red;
    }
    &::-webkit-scrollbar-thumb {
      // background: red;
      background: rgba(0, 0, 0, 0.2);
      border-radius: 5px;
    }
    &::-webkit-scrollbar {
      background-color: rgba(0, 0, 0, 0);
      width: 5px;
      border-radius: 10px;
    }
  }
  .article_content_item {
    cursor: pointer;
    width: 100%;
    height: rem(260);
    padding: rem(30) 0;
    box-sizing: border-box;
    display: flex;
    border-bottom: 1px solid rgba(242, 209, 209, 1);
  }
  .article_content_item_left {
    width: rem(400);
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      display: block;
      border-radius: 5px;
    }
  }
  .article_content_item_right {
    width: rem(1000);
    margin-left: rem(50);
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    // justify-content: space-between;
  }
  .article_content_item_right_title {
    font-size: rem(24);
    color: #000;
    font-weight: bold;
  }
  .article_content_item_right_time {
    font-size: rem(14);
    color: #333;
    margin-top: rem(30);
  }
}
</style>
